// import $ from "jquery";
// import { checkNested, getConfig } from "../../scripts/general_functions.js";
import breadcrumb from '../breadcrumb';
// import dayjs from "dayjs";
import language from "../../../scripts/translation";

import { search } from "./search_template";
import { doSearch } from "./search_functions";

export const fullsearch = (val) => {
  let searchOn = $.trim(val);
  const breadcrumbHtml = breadcrumb();

  doSearch(searchOn);

  return search({
    breadcrumbHtml: breadcrumbHtml,
    inputPlaceholder: language("SEARCH_INPUT"),
    filterHeader: language("SEARCH_FILTERHEADER"),
    sortByLabel: language("SEARCH_SORTBY"),
    sortByRelevanseText: language("SEARCH_RELEVANCE"),
    sortByDateText: language("SEARCH_DATE")
  });
}
